module.exports = __webpack_public_path__ + "static/media/swingSubImg1.7980a11c.png";